import React from "react";

import classes from "./styles.module.scss";
import { ModalBody } from "Components/ReactstrapSlim";
import CloseButton from "../../CloseButton";

interface ModalBodyGenericProps {
   toggle(): void;
}

const ModalBodyGeneric: React.FC<ModalBodyGenericProps> = ({ toggle }) => {
   return <ModalBody className={classes.modalBody}>
      <CloseButton toggle={toggle} />
      <div className={classes.header}>
         <div className={classes.header1}>Thank you!</div>
         <div className={classes.header2}>We’ll be in touch shortly.</div>
      </div>
   </ModalBody>
}

export default ModalBodyGeneric;